export default __webpack_public_path__ + "static/media/radiolight.9095b91d.png";